export const centrePrefix = {
  "AMBEHTA PEER": "AMB",
  BAHADARPUR: "BAH",
  BEHAT: "BEH",
  BIHARIGARH: "BIH",
  BILASPUR: "BIP",
  MUZAFFARABAD: "MUZ",
  CHHUTMALPUR: "CHH",
  CHILKANA: "CHK",
  DEOBAND: "DBD",
  GANGOH: "GAN",
  GATHEDA: "GHA",
  GURUNANAKPURA: "GUR",
  "HARIYA BAANS": "HAR",
  ISLAMNAGAR: "ISL",
  "KHERA MUGHAL": "KHE",
  "LAKHNAUTI KALAN": "LAK",
  "MANJHOL JABARDASTPUR": "MAN",
  NAGAL: "NGL",
  NAKUR: "NAK",
  NANAUTA: "NAN",
  PATHER: "PAT",
  PHANDPURI: "PHA",
  RANDHOL: "RAN",
  RASOOLPUR: "RAS",
  "SAHARANPUR-I": "S1R",
  BADGAON: "BAD",
  "SAHARANPUR-II": "S2R",
  "SAHARANPUR-V": "STP",
  "SAHARANPUR-III": "S3R",
  "SAHARANPUR-IV": "S4R",
  "SAMASPUR KALAN": "SAM",
  SANTOUR: "SAN",
  SHERMAU: "SHE",
  "SONA ARJUNPUR": "SON",
  TALHAPUR: "TAP",
  TEETRON: "TTN",
  "TALHERI BUJURG": "TAB",
};

export const deptList = {
  "A.C.T": "A.C.T",
  ACCOMODATION: "ACCOMODATION",
  ACCOUNTS: "ACCOUNTS",
  "AREA ASSISTANT JATHEDAAR": "A.ASST.JATHEDAAR",
  "AREA JATHEDAAR": "AREA JATHEDAAR",
  "AREA OFFICE": "AREA OFFICE",
  "AREA SECRETARY": "AREA SECRETARY",
  "B.A.V": "B.A.V",
  "BAAL PANDAL": "BAAL PANDAL",
  "BAAL PATHI": "BAAL PATHI",
  "BAAL SATSANG KARTA": "BSK",
  "BADGE SECTION": "BADGE SECTION",
  BAGHWANI: "BAGHWANI",
  BANNER: "BANNER",
  "BOOK READER": "BOOK READER",
  "BOOK STALL": "BOOK STALL",
  "C.T.": "C.T.",
  CANTEEN: "CANTEEN",
  CCTV: "CCTV",
  "CENTER STORE": "CEN. STORE",
  CHABEEL: "CHABEEL",
  "COMMITTEE MEMBER": "COMM. MEMBER",
  "CO-ORDINATOR": "CO-ORDINATOR",
  ELECTRIC: "ELECTRIC",
  "ENG.WORKSHOP": "ENG.WORKSHOP",
  "FIRE FIGHTING": "FIRE FIGHTING",
  "FIRST AID": "FIRST AID",
  "GATE SEWA": "GATE SEWA",
  "GUEST HOUSE": "GUEST HOUSE",
  HELPLINE: "HELPLINE",
  "JATHA CO-ORDINATOR": "JATHA CO-ORD",
  "LAND MAINTENANCE": "LAND MAINT.",
  "LAND/LEGAL": "LAND/LEGAL",
  LANGAR: "LANGAR",
  "LOST & FOUND": "LOST & FOUND",
  LUGGAGE: "LUGGAGE",
  MEDICAL: "MEDICAL",
  MOBILE: "MOBILE",
  NDRS: "NDRS",
  OBSERVER: "OBSERVER",
  OFFICE: "OFFICE",
  "OFFICE RECEPTION": "OFF. RECEPTION",
  PANDAL: "PANDAL",
  PARKING: "PARKING",
  "PATH SEWA": "PATH SEWA",
  PATHI: "PATHI",
  PRESIDENT: "PRESIDENT",
  RECEPTION: "RECEPTION",
  SANITATION: "SANITATION",
  "SATSANG KARTA": "SATSANG KARTA",
  SECRETARY: "SECRETARY",
  SECURITY: "SECURITY",
  "SEWA SAMITI": "SEWA SAMITI",
  SOUND: "SOUND",
  STAGE: "STAGE",
  STORE: "STORE",
  "TILE FACTORY": "TILE FACTORY",
  TRAFFIC: "TRAFFIC",
  TRANSPORT: "TRANSPORT",
  "WATER SUPPLY": "WATER SUPPLY",
  WORKSHOP: "WORKSHOP",
  ADMINISTRATION: "ADMIN",
  "NIGHT SECURITY(OPEN)": "N.SECURITY(OPEN)",
  "OPEN SEWA(OSS)": "OSS",
  "TRANSPORT - RAILWAY": "TRANSPORT-R.WAY",
  "FRUIT STALL": "FRUIT STALL",
  "NAAMDAAN WELFARE": "ND WELFARE",
  "SATSANG READER": "SR",
  "MAINTENANCE & SAFAI": "SAFAI",
};
